import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeUNLocationListItem extends SearchModelBase {
    id: number = 0;
    unCode: string = '';
    unPortName: string = '';
    unCountry: string = '';
    usCode: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'UNCode', width: 100, dataIndex: 'unCode'}),
        XCol.Create({ col: 1, text: 'Port Name', width: 300, dataIndex: 'unPortName'}),
        XCol.Create({ col: 2, text: 'Country', width: 80, dataIndex: 'unCountry'}),
        XCol.Create({ col: 3, text: 'USCode', width: 100, dataIndex: 'usCode'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeUNLocationListItem.prototype.unCode, orderByAscending: true };

    public static formatData(data: CodeUNLocationListItem[]) {
        return data.map((d: CodeUNLocationListItem) => ({
          ...d,
        }));
    }

}
